module.exports = __webpack_public_path__ + "img/icon-xml.0d6fd1a1.svg";